<template>
  <el-card class="box-card">
    <el-collapse-item  name="4">
      <template slot="title">
        <span class="title">{{$t('message.title.workflow')}}</span>
      </template>
    <div class="right" style="" >
      <div class="space">
        <i class="iconfont icon-liucheng history"></i>
        <span style="font-size:16px;">
          {{$t('message.title.summary')}}
        </span>
      </div>
      
      <div class="workFlowView">
        <div class="workFlowView-bg">
          <img src="@assets/changeWorkflow/bg.png" alt="">
        </div>
        <el-steps :active="process_Num" class="workFlowView-steps" align-center finish-status="success">
          <el-step v-for="status in statusInfoShow" :key="status.id" :title="status.name">
          </el-step>
        </el-steps>
      </div>

      <el-divider></el-divider>

      <div>
        <div style="padding: 4px;">
          <i class="iconfont icon-history history"></i>
          <span style="font-size:16px;">
            {{$t('message.title.history')}}
          </span>
        </div>
        
      </div>
      <div>
        <!-- 表格区域 -->
        <template>
          <el-table stripe :data="workflowTable" style="width: 100%;" max-height="290" border>
            <template v-for="(item,index) in tableHead">
              <!-- <el-table-column :prop="item.id" :label="item.name" :key="index" v-if="item.column_name != 'id'"></el-table-column> -->
              <el-table-column :prop="item.id" :label="item.name" :key="index"></el-table-column>
            </template>

          </el-table>
        </template>
      </div>
    </div>
    </el-collapse-item>
  </el-card>
</template>

<script>
import '@/assets/css/icon-swift.css'
export default {
  data(){
    return {
      
    }
  },
  props:['process_Num','statusInfoShow','workflowTable','tableHead'],
  mounted(){
  },
  created(){
    //console.log(this.statusInfoShow);
    //console.log('------------',this.gridOptions);
  }
}
</script>

<style scoped>
.workFlowView {
  overflow: hidden;
  margin-top: 20px;
  border-radius: 6px;
  background: var(--themeColor);
    /* background-image: linear-gradient(to right, #3ea4f9 , #4588f9); */
    position: relative;
  }
  
  .workFlowView-steps {
    margin-top: 40px;
    padding-bottom: 30px;
  }
  
  .workFlowView-bg {
    width: 80px;
    height: 120px;
    position: absolute;
    right: 0;
    top: 0;
  }
  
  .workFlowView-bg img {
    width: 100%;
    height: 100%;
  }
  
  .title {
    border-left: 8px solid var(--themeColor);
    padding-left: 12px;
    font-size: 18px;
    font-size: 18px;
    height: 18px;
    line-height: 18px;
  }
  
  .space {
    width: 100%;
    height: 20px;
  }
  
  .history {
    color: var(--themeColor);
    font-size: 16px;
    font-weight: 600;
  }
</style>